export enum UsageMetricKey {
    Verifications = 1,
    AutomaticAccountingAssistance = 2,
    CustomerInvoices = 3,
}

export const UsageMetricTitleKey: Record<UsageMetricKey, string> = {
    [UsageMetricKey.Verifications]: 'vossusage.metric.verifications',
    [UsageMetricKey.AutomaticAccountingAssistance]: 'vossusage.metric.automaticAccountingAssistance',
    [UsageMetricKey.CustomerInvoices]: 'vossusage.metric.customerInvoices',
};
